// start:ng42.barrel
export * from './UAParserService';
// end:ng42.barrel
